import { HttpClient, ListParams } from './http-client';
import { Observable } from 'rxjs';
import LivestockSummary, { ControlDates, CowChartEntry, InseminationChartEntry, LactationChartEntry, LatestDateResponse, SomaticCellsChartEntry, SummaryInfo } from '../interfaces/livestock-summary';
import Paginate from '../interfaces/paginate';
import LivestockMetabolism from '../interfaces/livestock-metabolism';
import LivestockSomaticCells from '../interfaces/livestock-somatic-cells';
import LivestockReproduction from '../interfaces/livestock-reproduction';

export class LivestockSummaryService extends HttpClient {
  index(
    farmId: string,
    type: 'summary' | 'metabolism' | 'somatic_cells' | 'reproduction',
    params?: ListParams
  ): Observable<Paginate<LivestockSummary|LivestockMetabolism|LivestockSomaticCells|LivestockReproduction>> {
    return this.get<Paginate<LivestockSummary|LivestockMetabolism|LivestockSomaticCells|LivestockReproduction>>(
      `/api/farms/${farmId}/livestock/summary/dairy/table/${type}`,
      params
    );
  }

  summaryType(farmId: string, id: string): Observable<LivestockSummary> {
    return this.get<LivestockSummary>(
      `/api/farms/${farmId}/livestock/summary/dairy/type/${id}`
    );
  }

  summaryInfo(farmId: string, date: string, summary: string): Observable<SummaryInfo> {
    return this.get<SummaryInfo>(
      `/api/farms/${farmId}/livestock/summary/dairy/getDays/${date}/${summary}`
    );
  }

  somaticCellsChart(farmId: string, date: string): Observable<SomaticCellsChartEntry> {
    return this.get<SomaticCellsChartEntry>(
      `/api/farms/${farmId}/livestock/summary/dairy/somaticChart/${date}`
    );
  }

  lactationChart(farmId: string, date: string): Observable<LactationChartEntry[]> {
    return this.get<LactationChartEntry[]>(
      `/api/farms/${farmId}/livestock/summary/dairy/lactationChart/${date}`
    );
  }

  cowChart(farmId: string, date: string): Observable<CowChartEntry[]> {
    return this.get<CowChartEntry[]>(
      `/api/farms/${farmId}/livestock/summary/dairy/cowChart/${date}`
    );
  }

  inseminationChart(farmId: string, date: string): Observable<InseminationChartEntry> {
    return this.get<InseminationChartEntry>(
      `/api/farms/${farmId}/livestock/summary/dairy/inseminationChart/${date}`
    );
  }

  getConfigurations(farmId: string, title: string): Observable<number> {
    return this.get<number>(
      `/api/farms/${farmId}/livestock/summary/dairy/getConfigurations/${title}`
    );
  }

  saveConfigurations(farmId: string, title: string, value: number): Observable<void> {
    return this.post(
      `/api/farms/${farmId}/livestock/summary/dairy/saveConfigurations/${title}/${value}`
    );
  }

  displayControlDates(farmId: string, date: string): Observable<ControlDates> {
    return this.get<ControlDates>(
      `/api/farms/${farmId}/livestock/summary/dairy/displayControlDates/${date}`
    );
  }

  getLatestDate(farmId: string): Observable<LatestDateResponse> {
    return this.get<LatestDateResponse>(
      `/api/farms/${farmId}/livestock/summary/dairy/latestDate`
    );
  }

  getMessageStatus(farmId: string): Observable<string> {
    return this.get(
      `/api/farms/${farmId}/livestock/summary/dairy/message`
    );
  }
}
